// Top chrome strip for the gallery. Back button (history back),
// filename with "N of M · size" label, three-dots to open the
// gallery action sheet.

import { ChevronLeft, MoreVertical } from "lucide-react";

interface Props {
  fileName: string;
  indexLabel: string;
  sizeLabel: string;
  onBack: () => void;
  onMore: () => void;
}

export function GalleryTopBar({
  fileName,
  indexLabel,
  sizeLabel,
  onBack,
  onMore,
}: Props) {
  return (
    <div className="pointer-events-auto flex items-center gap-3 bg-gradient-to-b from-black/70 to-transparent px-3 py-2 text-white">
      <button
        type="button"
        onClick={onBack}
        aria-label="Close gallery"
        className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-white/20"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm font-medium">{fileName}</div>
        <div className="truncate text-xs text-white/70">
          {indexLabel} · {sizeLabel}
        </div>
      </div>
      <button
        type="button"
        onClick={onMore}
        aria-label="More actions"
        className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-white/20"
      >
        <MoreVertical className="h-5 w-5" />
      </button>
    </div>
  );
}
